"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _setSessionState["default"];
  }
});
var _setSessionState = _interopRequireDefault(require("./setSessionState"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }